import React from 'react';
import KickImage from 'Reuseables/KickImage';
import _ from "lodash";
import moment from "moment";
import Countdown from "react-countdown-now";
import { connect } from "react-redux";
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  Row
} from "reactstrap";
import styled from "styled-components";
import { normalizeBrand } from "../../utils";

import CloseIcon from "../../images/close-button-white.png";
import Warning from "../../images/danger.png";
import Timer from "../../images/stopwatch.png";
import { TextRupiah } from "../Text";

import {
  ADMINISTRATOR,
  APPROVED,
  BARU,
  BEKAS,
  CACAT,
  CANCELLED,
  DRAFT,
  LISTING,
  MORE_INFO,
  NO_BOX,
  REJECTED,
  SEMPURNA,
  SUSPEND,
  UNDER_REVIEW,
  WAIT_CONFIRM,
  WAIT_CONSIGN,
  emptyImage,
  getCloudImageUrl
} from "../../utils";

const renderer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return (
      <TimerWrapper>
        <KickImage src={Warning} alt="warning" />
        <span className="warning">
          Please confirm your order quickly, before it gets rejected
          automatically.
        </span>
      </TimerWrapper>
    );
  } else {
    // Render a countdown
    return (
      <TimerWrapper>
        <KickImage src={Timer} alt="timer" />
        <span>
          {hours}:{minutes}:{seconds}
        </span>
      </TimerWrapper>
    );
  }
};

const sneakerCondition = condition => {
  switch (condition) {
    case "BARU":
      return "Brand New";
    case "BEKAS":
      return "Used";
    case "PRISTINE":
      return "Pristine";
    case "GOOD":
      return "Good";
    case "WELL_USED":
      return "Well Used";
    case "LIKE_NEW":
      return "Like New";
    case "VINTAGE":
      return "Vintage";

    default:
      return "Brand New";
  }
};

const handbagCondition = data => {
  return detailHandbagCondition(data);
};

const detailHandbagCondition = data => {
  const condition = data
    .filter(item => item.value)
    .map(item => item.display_name)
    .join(" / ");

  return condition;
};

const accessories = condition => {
  if (condition === true) {
    return "Missing Accessories";
  } else {
    return "Complete Accessories";
  }
};

const boxHandbag = value => {
  if (value === true) {
    return "";
  } else {
    return "Missing Box";
  }
};

const dustBag = value => {
  if (value === true) {
    return "";
  } else {
    return "KA Dust Bag";
  }
};

const ModalAcceptOrder = props => {
  const uniqueDefects =
    props.userSell === null ? [] : _.uniqBy(props.userSell.defects, "name");
  const dustBagCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "DUST_BAG")
    : {};
  const boxCondition = uniqueDefects
    ? uniqueDefects.find(a => a.name === "BOX")
    : {};
  const category =
    props.onData &&
    props.onData.sale_product &&
    props.onData.sale_product.category_name;
  const categoryUrl =
    category === "apparels" || category === "Apparels"
      ? "apparels"
      : category === "lifestyles"
        ? "electronics-collectibles"
        : category === "handbags"
          ? "luxury"
          : category;
  const slug =
    props.onData &&
    props.onData.sale_product &&
    props.onData.sale_product.product_variant &&
    props.onData.sale_product.product_variant.slug;
  const product_variant_id =
    props.onData &&
    props.onData.sale_product &&
    props.onData.sale_product.product_variant_id;
  const display_name =
    props.onData &&
    props.onData.sale_product &&
    props.onData.sale_product.display_name;
  const onErrorImg = e => {
    e.target.src = emptyImage(category);
  };

  return (
    <Modal
      isOpen={props.isOpen}
      className="kick-modal detail-selling"
      toggle={() => props.onToggle(null, null, "shouldRefetch")}
    >
      <div className="header-expiry">
        <div className="close-icon-wrapper">
          <KickImage
            onClick={() => props.onToggle(null, null, "shouldRefetch")}
            src={CloseIcon}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="tracking-wrapper">
          <span>SALES CONFIRMATION</span>
        </div>
      </div>
      <Container>
        <div className="consignment-approved">
          <div className="ca-sections">
            <span>Consignment ID:</span>
            <span>
              {props.onData &&
                props.onData.sale_product &&
                props.onData.sale_product.consignment_id !== null
                ? props.onData.sale_product.consignment_id
                : "-"}
            </span>
          </div>
          <div className="ca-sections">
            <span>Approved At:</span>
            <span>
              {moment(props.user_sell && props.user_sell.approved_at).format(
                "DD/MM/YYYY"
              )}
            </span>
          </div>
        </div>
        <ModalBody>
          <Row>
            <Col>
              <div className="wrapper-image">
                <KickImage
                  src={
                    props.onData &&
                      props.onData.sale_product &&
                      props.onData.sale_product.image_url !== null
                      ? getCloudImageUrl(
                        props.onData.sale_product &&
                        props.onData.sale_product.image_url,
                        400
                      )
                      : emptyImage(category)
                  }
                  alt={display_name}
                  onError={e => onErrorImg(e)}
                />
              </div>
              <div className="wrapper-image title">
                <span>
                  {normalizeBrand(
                    props.onData &&
                    props.onData.sale_product &&
                    props.onData.sale_product.brand_name
                  )}
                </span>
                <span
                  onClick={() =>
                    props.history.push(
                      `/${categoryUrl}/${product_variant_id}/${slug}`
                    )
                  }
                >
                  {display_name}
                </span>
                <TextRupiah
                  prefix="IDR. "
                  value={
                    props.onData &&
                    props.onData.sale_product &&
                    props.onData.price
                  }
                  bold={true}
                />
                <span>
                  {props.onData &&
                    props.onData.sale_product &&
                    props.onData.sale_product.SKU}
                </span>
              </div>
            </Col>
          </Row>
          {category === "handbags" ? (
            <Row style={{ justifyContent: "center" }}>
              <div style={{ textAlign: "center" }}>
                <span>
                  {sneakerCondition(props.userSell.sneakers_condition)} /{" "}
                  {accessories(props.userSell.missing_accessories)}{" "}
                  {dustBagCondition && dustBagCondition.value
                    ? null
                    : `/ ${dustBag(dustBagCondition)} `}
                  {boxCondition && boxCondition.value
                    ? null
                    : `/ ${boxHandbag(boxCondition)} `}
                  {props.userSell.sneakers_defect
                    ? `/ ${handbagCondition(uniqueDefects)}`
                    : null}
                </span>
              </div>
            </Row>
          ) : (
            <Row>
              <ButtonWrapper>
                <Button className="btn-black flat">
                  US{" "}
                  {props.onData &&
                    props.onData.sale_product &&
                    props.onData.sale_product.size.US}
                </Button>
                <Button className="btn-black flat">
                  {infoString(
                    props.onData &&
                    props.onData.sale_product &&
                    props.onData.sale_product.sneakers_condition
                  )}
                </Button>
                <Button className="btn-black flat">
                  {infoString(
                    props.onData &&
                      props.onData.sale_product ?
                      props.onData.sale_product.box_condition : null
                  )}
                </Button>
                <Button className="btn-black flat">
                  {infoString(
                    props.onData &&
                    props.onData.sale_product &&
                    props.onData.sale_product.missing_accessories
                  )}
                </Button>
              </ButtonWrapper>
            </Row>
          )}
          <Row>
            <Col className="col-accept-order">
              {props.successStatus === true && props.successType === true ? (
                <div>
                  <span>
                    CONGRATULATIONS!
                    <br />
                    Please deliver the goods ASAP and input the AWB on your Seller Dashboard. Please ensure you've read the instructions we've sent to your email {props.email}
                  </span>
                  <br />
                  <Button
                    onClick={() => props.onToggle(null, null, "shouldRefetch")}
                    className="btn-white flat"
                  >
                    Back to Dashboard
                  </Button>
                </div>
              ) : props.successStatus === true &&
                props.successType === false ? (
                <div>
                  <span>
                    YOU HAVE FAILED TO COMPLETE THE SALE.
                    <br /> Very unfortunate of this to happen, your seller point
                    will be deducted and this listing will be deleted from your
                    dashboard. Please make sure you consistently update your
                    listings.
                  </span>
                  <br />
                  <Button
                    onClick={() => props.onToggle(null, null, "shouldRefetch")}
                    className="btn-white flat"
                  >
                    Back to Dashboard
                  </Button>
                </div>
              ) : (
                <div className="col-accept-order">
                  <TimerWrapper>
                    <Countdown
                      date={
                        moment(
                          props.onData && props.onData.customer_paid
                        ).valueOf() + 259200000
                      }
                      daysInHours={true}
                      renderer={renderer}
                    />
                  </TimerWrapper>
                  <span>Are you sure you want to complete this sales?</span>
                  <Button
                    onClick={() => props.onAccept(true, props.onData.id)}
                    className="btn-white flat"
                  >
                    YES
                  </Button>
                  <span
                    className="text-reject-sale"
                    onClick={() => props.onAccept(false, props.onData.id)}
                  >
                    No, reject this sale.
                  </span>
                  <span className="notes-reject">
                    By rejecting a sale, your point will be deducted
                    accordingly.
                  </span>
                </div>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Container>
    </Modal>
  );
};

const TimerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  justify-content: center;

  img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .warning {
    width: 50%;
  }
`;

const ButtonWrapper = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 0.5rem;
`;

const infoString = data => {
  switch (data) {
    case SEMPURNA[0]:
      return SEMPURNA[2];
    case CACAT[0]:
      return CACAT[1];
    case NO_BOX[0]:
      return NO_BOX[1];
    case BARU[0]:
      return BARU[2];
    case BEKAS[0]:
      return BEKAS[2];
    case APPROVED:
      return LISTING[0];
    case SUSPEND:
      return LISTING[1];
    case DRAFT[0]:
      return DRAFT[1];
    case MORE_INFO[0]:
      return MORE_INFO[1];
    case CANCELLED[0]:
      return CANCELLED[1];
    case WAIT_CONFIRM[0]:
      return WAIT_CONFIRM[1];
    case WAIT_CONSIGN[0]:
      return WAIT_CONSIGN[1];
    case UNDER_REVIEW[0]:
      return UNDER_REVIEW[1];
    case REJECTED[0]:
      return REJECTED[1];
    case false:
      return "Complete Accessories";
    case true:
      return "Missing Accessories";
    case 0:
      return "Complete Accessories";
    case 1:
      return "Missing Accessories";
    default:
      return ADMINISTRATOR;
  }
};

const mapStateToProps = (state) => ({
  email: state.dataAuth.userdata.email
});

export default connect(mapStateToProps, null)(ModalAcceptOrder);
